import { TApplicationState } from '../../types/redux';

export function selectIsCompareAdded(state: TApplicationState): boolean {
  return Boolean(state.compare.isAdded);
}
